import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          success:
            "group-[.toaster]:border-emerald-500 group-[.toaster]:bg-emerald-50 group-[.toaster]:text-emerald-950",
          error:
            "group-[.toaster]:border-red-600 group-[.toaster]:bg-red-50 group-[.toaster]:text-red-950",
          warning:
            "group-[.toaster]:border-amber-500 group-[.toaster]:bg-amber-50 group-[.toaster]:text-amber-950",
          info:
            "group-[.toaster]:border-blue-500 group-[.toaster]:bg-blue-50 group-[.toaster]:text-blue-950",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
